import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService, IdDescription } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class BaseReferenceService extends BaseService {
  constructor(baseRoute: string) {
    super(baseRoute);
  }

  get(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(this.apiUrl);
  }
}
